/* unplugin-vue-components disabled */import { render } from "./splash.vue?vue&type=template&id=4974cc09"
import script from "./splash.vue?vue&type=script&lang=js"
export * from "./splash.vue?vue&type=script&lang=js"

import "./splash.vue?vue&type=style&index=0&id=4974cc09&lang=css"

import exportComponent from "C:\\Users\\小刘\\Desktop\\wanwei\\cydf-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__